import './styles.scss';
import React, { useEffect } from 'react';
// Components
import {
    GeckoIcon,
    GeckoBtn,
    GeckoModalService,
    GeckoModal
} from '@geckolabs/gecko-react-ui';
import SessionSingle from '../../../../components/SessionSingle';
// Services
import AdminService from '../../services/AdminService';
import AttendanceService from '../../services/AttendanceService';
import DataService from '../../services/DataService';
import EventService from '../../services/EventService';
import DateUtils from '../../../../services/DateUtils';
import {__, STR_KEY} from '../../../../services/Translate';
import GeckoStore from '../../../../services/GeckoStore';
import RsvpService from '../../../../services/RsvpService';
import { replaceSessions } from '../../../../redux/actions';
import { $state, $stateParams } from '../../../../router';
// Constants
import { EVENT_DELIVERY_METHOD_ONLINE } from '../../constants';

const Sessions = ({ sessions, attendance }) => {
    let sessionInterval;

    useEffect(() => {
        // Clear setInterval if all booked sessions check in time has passed
        if (!sessions.filter(session => !session.checkin_started).length) return clearInterval(sessionInterval);

        // Update 'Your Upcoming Sessions' list
        sessionInterval = setInterval(() => {
            DataService.get().then(data => {
                return JSON.stringify(data.sessions) !== JSON.stringify(sessions) ?
                    GeckoStore.redux.dispatch(replaceSessions(data.sessions)) : null;
            });
        }, 60000);

        // Clear the interval when component unmounts
        return () => clearInterval(sessionInterval);
    }, [sessions]);

    if (!sessions || !sessions.length) return null;

    const filteredSessions = sessions.filter(session => {
        // Only show only ONLINE sessions
        if (session.delivery_method !== EVENT_DELIVERY_METHOD_ONLINE) return false;
        // Allow admins to see past sessions
        if (!AdminService.isAdmin()) {
            return session.id !== attendance.event_id && !RsvpService.hasEventPassed(session);
        }
        return session.id !== $stateParams.event_id;
    });

    if (!filteredSessions.length) return null;

    return (
        <div className="sessions-container col gecko-ui-card card">
            <h1 className="sessions-heading branded-text">{__(STR_KEY.VIDEO_SESSIONS_TITLE)}</h1>
            <SortSessionTimes sessions={filteredSessions} />
        </div>
    );
}

export const sessionRedirectHandler = (session) => {
    const eventId = EventService.eventId();

    // Online sessions WITHOUT a video_uuid should be directed to the contact's RSVP
    if (session.video_uuid) {
        // Navigate to session's stream page
        return $state.go('stream', {
            account_uuid: $stateParams.account_uuid,
            contact_uuid: $stateParams.contact_uuid,
            event_id: session.id
        });
    }

    // Navigate back to the RSVP page and open the session joining details.
    AttendanceService.redirectToRsvpPage(eventId).then(() => new GeckoModalService().open(() => {
        return (
            <GeckoModal className="modal-session-single" >
                <SessionSingle id={session.parent_id} event={eventId} />
            </GeckoModal>
        );
    }));
}

export const SessionItem = ({ session }) => {

    const renderSessionBtn = () => {
        const title = AdminService.isAdmin() ? __(STR_KEY.VIDEO_SESSIONS_BTN_OPEN) : __(STR_KEY.VIDEO_SESSIONS_BTN_JOIN);

        if ((session.checkin_started && !AdminService.isAdmin()) || (session.video_uuid && AdminService.isAdmin())) {
            return (
                <GeckoBtn
                    name={title}
                    id="session-open"
                    handler={() => sessionRedirectHandler(session)}
                    icon="fa-user-check"
                    type={"primary"} 
                    {... !AdminService.isAdmin() && {role: 'link'}}
                    />
            )
        }
        return null;
    }

    return (
        <div className="session-item-container">
            <h2 className="session-title">{session.title}</h2>
            <div className="session-time-container d-flex flex-row">
                <p><GeckoIcon icon="fa-clock" /> {DateUtils.renderStartDateTimeEndDateTime(session.start_datetime, session.end_datetime, '-')} ({ DateUtils.eventTimezone })</p>
            </div>
            {renderSessionBtn()}
        </div>
    );
}

export const SortSessionTimes = ({ sessions }) => {
    const sortedTimes = (sessions || []).sort((a, b) => (a.start_datetime > b.start_datetime) ? 1 : ((b.start_datetime > a.start_datetime) ? -1 : 0));
    return sortedTimes.map((session, index) => {
        return <SessionItem key={index} session={session} />
    });
}

export default Sessions;
